import clsx from 'clsx';
import type React from 'react';

import { TextSkeleton } from '@gitbook/spine-react';

import { PageDocumentSkeleton } from './PageDocumentSkeleton';

/**
 * Skeleton for the page body.
 */
export function PageSkeleton(props: { header?: React.ReactNode }) {
    const { header } = props;

    return (
        <div className="flex flex-1 flex-col px-6 py-4 md:px-24">
            <div className="mx-auto flex w-full max-w-[--block-wrapper-max-width] flex-col">
                {header}
                <div className={clsx('flex flex-col gap-6 pb-6', header ? 'pt-0' : 'pt-6')}>
                    <div>
                        <TextSkeleton className="text-ui-heading-large">
                            Title of the page
                        </TextSkeleton>
                    </div>
                    <PageDocumentSkeleton />
                </div>
            </div>
        </div>
    );
}
